import React, { useState, useEffect } from "react";
import axiosInstance from '../common/axios';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { getSupplierInfo,saveSupplierInfo, getCompanyTypes, updateSupplierInfo,fetchSuppliers } from '../service/supplierService';

const SupplierManager: React.FC = () => {
  const [companyTypes, setCompanyTypes] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [newSupplier, setNewSupplier] = useState({
    supplierName: "",
    email: "",
    phone: "",
    contactPerson: "",
    gstNumber: "",
    panNumber: "",
    website: "",
      companyType: "",
  });
    
  const emptySupplier =  {
    supplierName: "",
    email: "",
    phone: "",
    contactPerson: "",
    gstNumber: "",
    panNumber: "",
    website: "",
      companyType: "",
  }

  useEffect(() => {
      
    fetchAllSuppliers();
    async function fetchCompanyTypes() {
      try {
        const response = await getCompanyTypes(); // API to get company types
        setCompanyTypes(response.data);
      } catch (error) {
        console.error('Failed to load company types', error);
      }
    }
    fetchCompanyTypes();
  }, []);

  const fetchAllSuppliers = async () => {
    const res = await fetchSuppliers();
    setSuppliers(res.data);
  };

  const handleSave = async () => {
    
     if (
    !newSupplier.supplierName ||
    !newSupplier.email ||
    !newSupplier.phone ||
    !newSupplier.contactPerson ||
    !newSupplier.companyType 
  ) {
    alert("Please fill in all required fields.");
    return;
  }

  // Email format check (extra layer beyond type="email")
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(newSupplier.email)) {
    alert("Please enter a valid email address.");
    return;
  }
  
    if (newSupplier.supplierId) {
      await updateSupplierInfo(newSupplier.supplierId, newSupplier); //axiosInstance.put(`/suppliers/${newSupplier.supplierId}`, newSupplier);
    } else {
      await saveSupplierInfo(newSupplier);  //axiosInstance.post("/suppliers", newSupplier);
    }
    setOpenForm(false);
    fetchAllSuppliers();
  };

  const handleViewDetails = (supplier: any) => {
    setSelectedSupplier(supplier);
    setOpenDetails(true);
  };
    
    const handleEditDetails = (supplier) => {
  setNewSupplier({
    supplierId: supplier.supplierId,
    supplierName: supplier.supplierName,
    email: supplier.email,
    phone: supplier.phone,
    contactPerson: supplier.contactPerson,
    gstNumber: supplier.gstNumber,
    panNumber: supplier.panNumber,
    website: supplier.website,
    companyType: supplier.companyType,
  });
  setOpenForm(true); // open the dialog
};
    
    // handle add (clear form)
const handleAddDetails = () => {
  setNewSupplier(emptySupplier); // reset to empty
  setOpenForm(true); // open the dialog in add mode
};

// handle close (clear after dialog closes)
const handleCloseForm = () => {
  setOpenForm(false);
  setNewSupplier(emptySupplier); // reset form after closing
};

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Supplier Management</h2>
      <Button variant="contained" color="primary" onClick={handleAddDetails}>
        Add Supplier
      </Button>

      {/* Supplier DataTable */}
      <Paper className="mt-4">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Supplier Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Contact Person</TableCell>
              <TableCell>Website</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {suppliers.map((s) => (
              <TableRow key={s.supplierId}>
                <TableCell>{s.supplierId}</TableCell>
                <TableCell>{s.supplierName}</TableCell>
                <TableCell>{s.email}</TableCell>
                <TableCell>{s.phone}</TableCell>
                <TableCell>{s.contactPerson}</TableCell>
                <TableCell>{s.website}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleViewDetails(s)}>
                    <Visibility />
                  </IconButton>
                  <IconButton onClick={() => handleEditDetails(s)}>
                    <Edit />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      {/* Add/Edit Supplier Form */}
      <Dialog open={openForm} onClose={() => setOpenForm(false)}>
        <DialogTitle>{newSupplier.supplierId ? "Edit Supplier" : "Add Supplier"}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Supplier Name"
            fullWidth
            value={newSupplier.supplierName}
            onChange={(e) => setNewSupplier({ ...newSupplier, supplierName: e.target.value })}
            required
          />
          <TextField
            margin="dense"
            label="Email"
            fullWidth
             type="email"
            value={newSupplier.email}
            onChange={(e) => setNewSupplier({ ...newSupplier, email: e.target.value })}
              InputProps={{
    readOnly: !!newSupplier.supplierId, // email readonly in edit mode
  }}
          />
          <TextField
            margin="dense"
            label="Phone"
            fullWidth
            value={newSupplier.phone}
            onChange={(e) => setNewSupplier({ ...newSupplier, phone: e.target.value })}
            required
          />
          <TextField
            margin="dense"
            label="Contact Person"
            fullWidth
            value={newSupplier.contactPerson}
            onChange={(e) => setNewSupplier({ ...newSupplier, contactPerson: e.target.value })}
            required
          />
          <TextField
            margin="dense"
            label="GST Number"
            fullWidth
            value={newSupplier.gstNumber}
            onChange={(e) => setNewSupplier({ ...newSupplier, gstNumber: e.target.value })}
          />
          <TextField
            margin="dense"
            label="PAN Number"
            fullWidth
            value={newSupplier.panNumber}
            onChange={(e) => setNewSupplier({ ...newSupplier, panNumber: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Website"
            fullWidth
            value={newSupplier.website}
            onChange={(e) => setNewSupplier({ ...newSupplier, website: e.target.value })}
          />

  <InputLabel id="companyType-label">Company Type</InputLabel>
  <Select
    labelId="companyType-label"
    id="companyType"
    value={newSupplier.companyType?.typeName || ""}
    onChange={(e) => {
      const selectedType = companyTypes.find((type) => type.typeName === e.target.value);
      setNewSupplier({ ...newSupplier, companyType: selectedType });
    }}
    label="Company Type"
    required
  >
    <MenuItem value="">
      <em>Select Company Type</em>
    </MenuItem>
    {companyTypes.map((type) => (
      <MenuItem key={type.id} value={type.typeName}>
        {type.typeName}
      </MenuItem>
    ))}
  </Select>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseForm}>Cancel</Button>
          <Button onClick={handleSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Supplier Details */}
      <Dialog open={openDetails} onClose={() => setOpenDetails(false)} fullWidth maxWidth="md">
        <DialogTitle>Supplier Details</DialogTitle>
        <DialogContent>
          {selectedSupplier && (
            <div>
              <p><strong>Name:</strong> {selectedSupplier.supplierName}</p>
              <p><strong>Email:</strong> {selectedSupplier.email}</p>
              <p><strong>Phone:</strong> {selectedSupplier.phone}</p>
              <p><strong>Contact Person:</strong> {selectedSupplier.contactPerson}</p>
              <p><strong>GST:</strong> {selectedSupplier.gstNumber}</p>
              <p><strong>PAN:</strong> {selectedSupplier.panNumber}</p>
              <p><strong>Website:</strong> {selectedSupplier.website}</p>

              <h3 className="mt-4 font-semibold">Addresses</h3>
              {selectedSupplier.addresses?.map((a: any, i: number) => (
                <div key={i} className="ml-4">
                  <p>{a.street1}, {a.city}, {a.state}, {a.country} - {a.postalCode}</p>
                </div>
              ))}

              <h3 className="mt-4 font-semibold">Certificates</h3>
              {selectedSupplier.certificates?.map((c: any, i: number) => (
                <div key={i} className="ml-4">
                  <p>{c.name} ({c.certificateNumber})</p>
                </div>
              ))}

              <h3 className="mt-4 font-semibold">Warehouses</h3>
              {selectedSupplier.warehouses?.map((w: any, i: number) => (
                <div key={i} className="ml-4">
                  <p>{w.name}, {w.city}, {w.country}</p>
                </div>
              ))}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDetails(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SupplierManager;
